// Plain text entering the contenteditable composer loses its \n paragraph breaks to HTML
// whitespace collapse — convert them to <br> (allowlisted, and strips turn it back into \n).

const escapeHtml = (text) => text
  .replace(/&/g, '&amp;')
  .replace(/</g, '&lt;')
  .replace(/>/g, '&gt;');

const plainTextToComposerHtml = (text) => escapeHtml(String(text || '')).replace(/\n/g, '<br>');

// Rich pitches always contain a tag; literal "<$5" has no letter after "<" and stays plain.
const looksLikeHtml = (text) => /<[a-z][^>]*>/i.test(String(text || ''));

// Stored pitch text -> composer html. Trust content_format when the API serves it; sniff when it
// doesn't, so a serializer gap escapes nothing (a rich pitch run through plainTextToComposerHtml
// shows literal <br>/</div> tags in the composer).
const composerHtmlFromStored = (raw, contentFormat) => {
  const isHtml = contentFormat ? contentFormat === 'html' : looksLikeHtml(raw);
  return isHtml ? String(raw || '') : plainTextToComposerHtml(raw);
};

export { plainTextToComposerHtml, looksLikeHtml, composerHtmlFromStored };
